import { useState, useEffect } from "react";
import Button from "../Button";
import HeaderBar from "../HeaderBar";
import useStateMachineWrapper from "../../helpers/useStateMachineWrapper";

const PreSaleNotifyComplete = (props) => {
  const {actions, state} = useStateMachineWrapper();
  return (<>
        <HeaderBar backPage={'intro'} nextPage={null}>
          <h1>Outstanding!</h1>
          <p>We'll be in touch when i3 Fiber is ready to go. In the meantime, if you have questions, please contact our sales team at sales@i3broadband.com</p>
        </HeaderBar>
        <Button size="large" color="purple" onClick={() => window.location.replace('/')}>Keep Exploring i3</Button>
    </>)

};

export default PreSaleNotifyComplete;
